"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __await = (this && this.__await) || function (v) { return this instanceof __await ? (this.v = v, this) : new __await(v); }
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
var __asyncDelegator = (this && this.__asyncDelegator) || function (o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
};
var __asyncGenerator = (this && this.__asyncGenerator) || function (thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = void 0;
var utils_1 = require("../model/utils");
var constant_1 = require("../utils/constant");
var customer_1 = require("../utils/customer");
var wrapper_1 = require("../utils/wrapper");
var fetchCustomers = function (listParams) { return __awaiter(void 0, void 0, void 0, function () {
    var customersUrl;
    return __generator(this, function (_a) {
        customersUrl = customer_1.fetchUrl(listParams);
        return [2 /*return*/, wrapper_1.getClients()
                .restClient.get(customersUrl)
                .then(function (_a) {
                var data = _a.data;
                return ({ data: data });
            })
                .catch(utils_1.errorHandler)];
    });
}); };
function list(listParams) {
    var _a;
    return __asyncGenerator(this, arguments, function list_1() {
        var resCustomers, customers, params;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, __await(fetchCustomers(listParams))];
                case 1:
                    resCustomers = _b.sent();
                    customers = resCustomers === null || resCustomers === void 0 ? void 0 : resCustomers.data;
                    if (!customers.content) return [3 /*break*/, 7];
                    return [4 /*yield*/, __await(customers.content)];
                case 2: return [4 /*yield*/, _b.sent()];
                case 3:
                    _b.sent();
                    if (!!customers.last) return [3 /*break*/, 6];
                    params = __assign(__assign({}, listParams), { cursor: (_a = customers === null || customers === void 0 ? void 0 : customers.pageable) === null || _a === void 0 ? void 0 : _a.urlSafeCursor });
                    return [5 /*yield**/, __values(__asyncDelegator(__asyncValues(list(params))))];
                case 4: return [4 /*yield*/, __await.apply(void 0, [_b.sent()])];
                case 5:
                    _b.sent();
                    _b.label = 6;
                case 6: return [3 /*break*/, 10];
                case 7: return [4 /*yield*/, __await(Promise.reject(resCustomers))];
                case 8: return [4 /*yield*/, _b.sent()];
                case 9:
                    _b.sent();
                    _b.label = 10;
                case 10: return [2 /*return*/];
            }
        });
    });
}
var getById = function (id) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, wrapper_1.getClients()
                .restClient.get(constant_1.CUSTOMER_URL + "/" + id)
                .then(function (_a) {
                var data = _a.data;
                return ({ data: data });
            })
                .catch(utils_1.errorHandler)];
    });
}); };
var update = function (customerData) { return __awaiter(void 0, void 0, void 0, function () {
    var updateData;
    return __generator(this, function (_a) {
        updateData = customer_1.dataMutation(customerData);
        return [2 /*return*/, wrapper_1.getClients()
                .restClient.put(constant_1.CUSTOMER_URL + "/" + customerData.id, updateData)
                .then(function (_a) {
                var data = _a.data;
                return ({ data: data });
            })
                .catch(utils_1.errorHandler)];
    });
}); };
var patch = function (customerId, customerData) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, wrapper_1.getClients()
                .restClient.patch(constant_1.CUSTOMER_URL + "/" + customerId, customerData)
                .then(function () { return ({ data: true }); })
                .catch(utils_1.errorHandler)];
    });
}); };
// delete is a keyword...
var deleteCustomer = function (customerId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, wrapper_1.getClients()
                .restClient.delete(constant_1.CUSTOMER_URL + "/" + customerId)
                .then(function () { return ({ data: true }); })
                .catch(utils_1.errorHandler)];
    });
}); };
var create = function (customerData) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, wrapper_1.getClients()
                .restClient.post("" + constant_1.CUSTOMER_URL, customerData)
                .then(function (_a) {
                var data = _a.data;
                return ({ data: data });
            })
                .catch(function (err) { return utils_1.errorHandler(err); })];
    });
}); };
var visits = function (customerId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, wrapper_1.getClients()
                .restClient.get(constant_1.CUSTOMER_URL + "/" + customerId + "/visits")
                .then(function (_a) {
                var data = _a.data;
                return ({ data: data });
            })
                .catch(function (err) { return utils_1.errorHandler(err); })];
    });
}); };
var techNotes = function (customerId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, wrapper_1.getClients()
                .restClient.get(constant_1.CUSTOMER_URL + "/" + customerId + "/technotes")
                .then(function (_a) {
                var data = _a.data;
                return ({ data: data });
            })
                .catch(function (err) { return utils_1.errorHandler(err); })];
    });
}); };
var customer = {
    list: list,
    getById: getById,
    update: update,
    patch: patch,
    create: create,
    deleteCustomer: deleteCustomer,
    visits: visits,
    techNotes: techNotes,
};
var init = function () { return customer; };
exports.init = init;
